export function getArrayPath(path?: string) {
    const substrings = path?.replaceAll(/(\/)/g, ',').replaceAll(/\s\//g, '');
    const paths = substrings?.split(',') ?? [];

    return paths
}